import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { FadeInOut } from "../../../Util/animations/Animations_v2";
import { useContext } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const GradingScore = ({ gradingData }) => {
  const { userData } = useContext(AppContext);

  return (
    <motion.div
      className="newGradingCaseDetailsWrapper"
      {...FadeInOut(userData.AnimationDisabled, 0.2)}
      key="newGradingCaseDetailsWrapper"
    >
      <div className="newGradingCaseDetailContainer">
        <div className="newGradingCaseDetailIconContainer">
          <FontAwesomeIcon icon={faUser} className="newGradingCaseDetailIcon" />
        </div>
        <h3 className="newGradingCaseDetailTitle">Your Score</h3>
        <h2 className="newGradingCaseDetailValue">
          {Math.floor(gradingData.gradeScore * 100) / 100}%
        </h2>
      </div>

      <div className="newGradingCaseDetailContainer">
        <div className="newGradingCaseDetailIconContainer">
          <FontAwesomeIcon
            icon={faUsers}
            className="newGradingCaseDetailIcon"
          />
        </div>
        <h3 className="newGradingCaseDetailTitle">
          Average First Attempt Score
        </h3>
        <h2 className="newGradingCaseDetailValue">
          {Math.floor(gradingData.AvgFirstAttemptGrade * 100) / 100}%
        </h2>
      </div>
    </motion.div>
  );
};

export default GradingScore;
